import { render, staticRenderFns } from "./loginByPwd.vue?vue&type=template&id=dc3e2570"
import script from "./loginByPwd.vue?vue&type=script&lang=js"
export * from "./loginByPwd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports